<template>
    <breeze-validation-errors class="my-4 p-4 bg-white rounded-md" />

    <form @submit.prevent="submit">
        <div>
            <breeze-label for="email" value="Email" class="font-bold text-white" />
            <breeze-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="mt-4">
            <breeze-label for="password" value="Password" class="font-bold text-white" />
            <breeze-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />

            <div class="mt-2 text-xs font-medium text-white">
                Your password must be at least 8 characters long with 1 letter, 1 number and 1 special character at a minimum.
            </div>
        </div>

        <div class="mt-4">
            <breeze-label for="password_confirmation" value="Confirm Password" class="font-bold text-white" />
            <breeze-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
        </div>

        <div class="flex items-center justify-end mt-8">
            <button type="submit"
                class="w-full px-4 py-2 bg-white border border-transparent rounded-md text-xl font-bold text-green tracking-widest transition ease-in-out duration-150 hover:bg-green hover:text-white hover:border-white"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Reset Password
            </button>
        </div>
    </form>
</template>

<script>
    import BreezeButton from '@/Components/Button'
    import BreezeGuestLayout from "@/Layouts/Guest"
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeValidationErrors from '@/Components/ValidationErrors'

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
            BreezeInput,
            BreezeLabel,
            BreezeValidationErrors,
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    }
</script>
